import { isPreviewRelease } from "../../../../appConfig";
import { ApptuitDatasource } from "../apptuit/ApptuitDatasource";

export class ProxyApiDatasource extends ApptuitDatasource {
  getUrl(url: string): string {
    if (isPreviewRelease) {
      return `/api-proxy-preview${url}`;
    }
    return `/api-proxy${url}`;
  }
}
